import { Observable, of } from 'rxjs'
import {
  catchError,
  distinctUntilChanged,
  map,
  take,
  timeout
} from 'rxjs/operators'
import { AppState } from 'src/app/core/core.state'

import { Component, OnInit } from '@angular/core'
import { Store } from '@ngrx/store'

import { configurationOptionSelectors } from '../configuration-option.selectors'
import { ConfigurationOptionService } from '../configuration-option.service'
import { Actions, ofType } from '@ngrx/effects'
import { NotificationService } from 'src/app/core/notification.service'
import { configurationOptionActions } from '../configuration-option.actions'
import { productActions } from '../../product/product.actions'
import { RequestQueryBuilder } from '@nestjsx/crud-request'
import { environment } from 'src/environments/environment'

@Component({
  selector: 'configuration-option-branding-tab',
  templateUrl: './show.component.html',
  styleUrls: ['./show.component.scss']
})
export class ConfigurationOptionBrandingTabComponent implements OnInit {
  public configFormValues$: Observable<any>
  public isCollapsed: boolean = true
  public isLoading$: Observable<boolean>
  public moduleConfigs: any = environment.moduleConfigs

  constructor(
    private store: Store<AppState>,
    private configOptionService: ConfigurationOptionService,
    private notificationService: NotificationService,
    private actions$: Actions
  ) {}

  ngOnInit() {
    this.isLoading$ = this.store.select(
      configurationOptionSelectors.selectIsLoading
    )

    this.store.dispatch(
      productActions.fetchMany({
        params: RequestQueryBuilder.create({
          // search: {
          //   allowAsLinkedProduct: {
          //     [CondOperator.EQUALS]: true
          //   }
          // }
        })
      })
    )
    this.configFormValues$ = this.store
      .select(configurationOptionSelectors.selectAll)
      .pipe(
        distinctUntilChanged((a, b) => JSON.stringify(a) == JSON.stringify(b)),
        map((configOptions) =>
          this.configOptionService.mapEntitiesToObject(configOptions)
        )
      )
  }

  public onSubmit(form): void {
    this.actions$
      .pipe(
        ofType(configurationOptionActions.upsertMany),
        take(1),
        timeout(4000),
        catchError((error) => of(null))
      )
      .subscribe((action) =>
        action
          ? this.notificationService.emit('alerts.success', 'success')
          : null
      )

    this.configOptionService.updateOrCreateMany(form)
  }
}
